import React from "react";

/**
 * Vollbreites Bildband unter dem Auftakt.
 *
 * Übernommen aus dem Entwurf brovko5: Das Bild trägt nicht als Dekoration,
 * sondern setzt die Aussage der Bildunterschrift ins Bild. Duotone in der
 * Markenfarbe, damit es zur Fläche gehört statt darauf zu liegen.
 */
const PlateBand = () => (
  <figure className="relative h-[clamp(320px,50vw,620px)] overflow-hidden bg-surface-spread">
    <img
      src="/img/rechenzentrum.jpg"
      alt="Symmetrischer Gang zwischen zwei Reihen schwarzer Serverschränke, Linienleuchten in der Decke, spiegelnder Doppelboden"
      className="h-full w-full object-cover opacity-90 mix-blend-luminosity [filter:grayscale(1)_contrast(1.06)_brightness(.82)]"
      width="2000"
      height="1333"
      loading="lazy"
    />
    {/* Verlauf in Markenfarben: dunkel oben links, Teal unten rechts */}
    <div
      className="absolute inset-0 bg-[linear-gradient(to_bottom_right,rgba(15,23,42,.78),rgba(30,41,59,.3)_55%,rgba(19,78,74,.55))]"
      aria-hidden="true"
    />
    <figcaption className="absolute inset-x-0 bottom-0 z-10 px-6 pb-7 text-sm text-ink-muted md:px-10 md:pb-9">
      <span className="mx-auto block max-w-[1320px]">
        Betrieb in deutschen Rechenzentren. Souveränität ist eine Architekturentscheidung, kein
        Zusatzmodul.
      </span>
    </figcaption>
  </figure>
);

export default PlateBand;
